import React from "react";
import Navigation from "../components/Navigation";
import SearchMovie from "../components/SearchMovie";
import Footer from "../components/Footer";
import { Helmet } from "react-helmet-async"; // Ajout pour les balises SEO
import { useLanguage } from "../contexts/LanguageContext";

const Recherche = () => {
  const { t } = useLanguage();

  return (
    <div
      className="search"
      style={{
        backgroundImage: `url(${process.env.PUBLIC_URL}/images/darkwater.jpg)`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundAttachment: "fixed",
        backgroundBlendMode: "overlay",
        backgroundColor: "#200211",
        opacity: "0.9",
        overflowX: "hidden",
        overflowY: "auto",
      }}
    >
      {/* Helmet pour le SEO */}
      <Helmet>
        <title>{`${t('search.seo.pageTitle')} - MovieFrenzy`}</title>

        <meta
          name="description"
          content={t('search.seo.pageDescription')}
        />

        <meta
          property="og:title"
          content={`${t('search.seo.pageTitle')} - MovieFrenzy`}
        />

        <meta
          property="og:description"
          content={t('search.seo.pageDescription')}
        />
      </Helmet>

      <Navigation />
      <div
        style={{
          backgroundColor: "#200211",
          opacity: "0.7",
          fontFamily: "Bebas Neue",
          padding: "0 16px",
          maxWidth: "33.33%",
          margin: "auto",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          borderRadius: "10px",
          border: "2.5px solid #D90093",
          marginTop: "50px",
          height: "clamp(50px, 15vw, 125px)",
          paddingBottom: "0",
          paddingTop: "1rem",
          boxShadow: "0 4px 15px #D9009330",
        }}
      >
        <h1
          style={{
            color: "#D90093",
            fontSize: "clamp(2rem, 4vw, 4rem)",
            textAlign: "center",
            textShadow: "0 2px 4px #20021130",
          }}
        >
          {t('search.pageTitle')}
        </h1>
      </div>
      <SearchMovie />
      <div
        style={{ maxWidth: '100%', maxHeight: '100%' }}
      >
        <Footer />
      </div>
    </div>
  );
};

export default Recherche;